import {registration} from 'backend/auth';
import {local} from 'wix-storage';
import wixLocation from 'wix-location';

$w.onReady(function () {
	
});
